<template>
  <div class="ctag">
    <div class="ctag__text">
      {{ text }}
    </div>
    <button class="ctag__close" @click.stop="$emit('remove', text)">
      <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 5.00391L12.9965 12.9737" stroke="#5B5D6B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5 12.9961L12.9965 5.02629" stroke="#5B5D6B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    text: {type: String}
  }
}
</script>

<style lang="sass" scoped>
.ctag
  padding: 7px 10px 5px
  border-radius: 4px
  background: colors.$anothersilver
  display: flex
  &__text
    color: colors.$gray3
    font-size: 16px
    line-height: 1.12
  &__close
    cursor: pointer
    margin-left: 10px
    width: 18px
    height: 18px
    margin-top: -1px
</style>